import { useEffect } from 'react';

interface SeoConfig {
  title: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string;
  canonical?: string;
}

function setMetaTag(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let tag = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(url: string) {
  let tag = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', url);
}

export default function useSeo(config: SeoConfig) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = config.title;

    if (config.description) {
      setMetaTag('description', config.description);
    }
    if (config.keywords) {
      setMetaTag('keywords', config.keywords);
    }
    if (config.canonical) {
      setCanonical(config.canonical);
    }

    // Open Graph
    setMetaTag('og:title', config.ogTitle || config.title, true);
    setMetaTag('og:description', config.ogDescription || config.description || '', true);
    setMetaTag('og:type', config.ogType || 'website', true);
    if (config.ogUrl) {
      setMetaTag('og:url', config.ogUrl, true);
    }
    if (config.ogImage) {
      setMetaTag('og:image', config.ogImage, true);
    }

    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image', true);
    setMetaTag('twitter:title', config.ogTitle || config.title, true);
    setMetaTag('twitter:description', config.ogDescription || config.description || '', true);
    if (config.ogImage) {
      setMetaTag('twitter:image', config.ogImage, true);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [
    config.title,
    config.description,
    config.keywords,
    config.ogTitle,
    config.ogDescription,
    config.ogType,
    config.ogUrl,
    config.ogImage,
    config.canonical,
  ]);
}